import styled from 'styled-components';

type WrapperProps = {
  isOpen: boolean;
};

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  transform: ${(props) => (props.isOpen ? 'scale(1)' : 'none')};
`;

const ModalBackground = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(150, 150, 150, .5);
`;

const ModalContainer = styled.div<WrapperProps>`
  margin-top: 20px;
  z-index: 3;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flext-start;
  min-width: 1054px;
  max-width: 90%;
  max-height: 90%;
  background-color: ${(props) => props.theme.colors.background_dashboard};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  cursor: default;
  overflow-y: auto;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  border-radius: 12px;
  padding-bottom: 10px;

  .title-container {
    padding: 27px 16px;
    height: 76px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      flex: 1;
    }

    button {
      background: inherit;

      &:hover {
        background: inherit;

        svg path {
          stroke: ${(props) => props.theme.colors.main_cta};
        }
      }
    }
  }

  .content-container {
    width: 100%;
    overflow-y: initial;
    padding: 0 16px;

    .item-name {
      margin-left: 30px;
    }
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background_dashboard};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.inactive};
    border-radius: 20px;
    border: 3px solid ${(props) => props.theme.colors.background_dashboard};
  }
`;

export default {
  Wrapper, ModalBackground, ModalContainer,
};
